import React, { useEffect, useState } from "react";
import { useApi } from "utils/hooks/use-api";
import styles from "./groups.module.scss";
import RefreshButton from "components/shared-ui/button/refresh-button";
import PageTitle from "components/shared-ui/pageTitle";
import Button from "components/shared-ui/button";
import { iamService } from "api/services/iam";
import { getDefaultRequestParams, getEmptyPage } from "redux/reducers/entity";
import { ITruncatedPaged } from "api/entities/page";
import { routeUtils } from "utils/route-utils";
import { useNavigate } from "react-router-dom";
import { IAMGroupSortField, IIAMGroup } from "api/entities/iam-groups";
import { IAMGroupTable } from "./group-table/group-table";
import {
  IAMEntityType,
  IIAMEntityRequestParams,
} from "api/entities/iam-entity";
import IAMGroupPanel from "./group-panel/group-panel";
import { DeleteConfirmation } from "../shared-ui/iam/dialogs/delete-confirmation";

export default function IAMGroups() {
  const [groupsApi, isGroupsLoading] = useApi();
  const [groupPages, setGroupsPage] = useState<ITruncatedPaged<IIAMGroup>>(
    getEmptyPage()
  );
  const [requestParams, setRequestParams] = useState<
    IIAMEntityRequestParams<IAMGroupSortField>
  >({ ...getDefaultRequestParams() });

  const navigate = useNavigate();

  const fetchData = (query?: IIAMEntityRequestParams<IAMGroupSortField>) => {
    const updatedQuery = { ...requestParams, ...query };
    groupsApi(iamService.getGroups(updatedQuery)).then(setGroupsPage);
    setRequestParams(updatedQuery);
  };

  const handleDeleteGroup = (GroupName: string) => {
    groupsApi(iamService.deleteGroup({ GroupName })).then(() => fetchData({}));
  };

  const handleAddGroupFormPanelOpen = () => {
    navigate(routeUtils.getRouteToNewIAMGroup());
  };

  const handleAddGroupFormPanelClose = () => {
    navigate(routeUtils.getRouteToIAMGroupList());
  };

  useEffect(() => {
    fetchData(requestParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!groupPages.marker) return;
    setRequestParams((prev) => ({ ...prev, marker: groupPages.marker }));
  }, [groupPages]);

  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Groups`}>
          <RefreshButton onClick={() => fetchData()} />
        </PageTitle>

        <div className={styles["action-buttons"]}>
          <Button
            testId="group-create-button"
            colors="primary"
            onClick={handleAddGroupFormPanelOpen}
          >
            Create
          </Button>
        </div>
      </div>

      <IAMGroupTable
        isLoading={isGroupsLoading}
        page={groupPages}
        isRowClickable
        hasManageColumn
        requestParams={requestParams}
        setRequestParams={fetchData}
      />
      <IAMGroupPanel
        embedded={false}
        fetchGroups={() => fetchData()}
        onClose={handleAddGroupFormPanelClose}
      />

      <DeleteConfirmation
        onDelete={handleDeleteGroup}
        type={IAMEntityType.Group}
      />
    </>
  );
}
